<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col v-bind:class="{'mt-md-n10': !noMarginTop}" cols="12" sm="12" :md="showFilters ? 4 : 2" class="pt-0 d-flex align-start">
        <v-card class="pb-2" elevation="0" outlined v-show="showFilters">
          <v-row id="player-seasons" class="mx-0 pt-2">
            <v-col cols="12" class="py-1">
              <v-card-title class="pa-0 header-font py-2" style="font-size: 22px;">{{ $t('general.filters') }}</v-card-title>
              <MediaModeForm v-show="showFilters" v-if="(currentUser.clientType === 'Media' || currentUser.clientType === 'Driblab')" :fields="mediaModeFields"
                :mediaMode="mediaMode" @mediaModeChange="onMediaModeChange($event)"
                :mediaModeData="mediaModeData" @mediaModeDataChange="onMediaModeDataChange($event)" selectorMode></MediaModeForm>
            </v-col>
            <!--Seasons-->
            <v-col cols="12" md="8" class="py-1">
              <div
                class="mr-5 pt-0 mt-0 primary--text font-weight-bold body-1"
              >
                {{ $t('table.clientLeagues.seasons') }}
              </div>
              <v-autocomplete 
                :items="playerSeasonData" 
                v-model="seasonDataSelectedModel"
                item-value="compoundId" 
                item-text="compoundText"
                clearable
                multiple 
                hide-details 
                dense 
                @blur="onSeasonBlur()" ref="autoCompleteSeasonRef"
                >
                <template v-slot:selection="{item,index}">
                  <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 w-90 black--text">
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="20" class="mr-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                    <span class="font-weight-bold text-ellipsis">{{item.seasonName}}</span>
                    <span class="mx-1">@</span>
                    <span class="font-weight-medium">{{item.teamName}}</span>
                  </v-chip>
                  <span
                        v-if="index === 3"
                        class="primary--text body-2 subheader-font"
                      >(+{{ seasonDataSelectedModel.length - 3 }} {{ $t('finishingMap.more') }})</span>
                </template>
                <template v-slot:item="{item}">
                  <v-card-text
                    class="pa-0 primary--text body-2 font-weight-medium d-flex align-center">
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/leagues/${item.leagueId}.png`"  type="image/png" height="20" class="mr-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                    <span class="d-flex flex-column">
                      {{item.seasonName}}
                      <span>{{item.teamName}}</span>
                    </span>
                  </v-card-text>
                </template>
              </v-autocomplete>
            </v-col>
            <!--Filter Games-->
            <v-col cols="12" md="4" class="py-1 pl-1">
              <v-card-title class="pa-0 mr-0 body-1 font-weight-bold primary--text flex-shrink-0">{{ $t("general.filter") }} {{ $t("searchbar.games") }}</v-card-title>
              <v-card-text class="pa-0 flex-shrink-1">
                <v-autocomplete clearable class="pa-0 body-2 mb-2" hide-details dense
                  v-model="groundModel"
                  :items="grounds"
                  item-text="name"
                  item-value="id"
                  @change="onSelectChange()"
                >
                  <template v-slot:selection="{item,index}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 w-80 d-flex justify-center black--text" v-if="index <= 0">
                      <span class="body-2 text-ellipsis">{{item.name}}</span>
                    </v-chip>
                  </template>
                  <template v-slot:item="{item}">
                    <span class="body-2">{{item.name}}</span>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <!--Games-->
            <v-col cols="12" class="py-1">
              <v-card-title class="pa-0 mr-4 body-1 font-weight-bold primary--text flex-shrink-0">{{ $t("searchbar.games") }}</v-card-title>
              <v-card-text class="pa-0 flex-shrink-1">
                <v-autocomplete clearable multiple menu-props="auto" hide-details dense class="pa-0 body-2 mb-2"
                  v-model="gamesModel"
                  :items="gamesFiltered"
                  item-text="name"
                  item-value="gameId"
                  @blur="updateShots()"
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @mousedown.prevent @click="toggleGames">
                      <v-list-item-content class="py-0">
                        <v-list-item-title class="body-2">{{ $t('finishingMap.selectAll') }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </template>
                  <template v-slot:selection="{item,index}">
                    <v-chip small color="lightSecondary lighten-2" class="body-2 mb-1 black--text" v-if="index <= 0">
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.homeTeamId}.png`" type="image/png" height="20" class="mr-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                      <span class="body-2 text-ellipsis">{{item.name}}</span>
                      <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.awayTeamId}.png`" type="image/png" height="20" class="ml-2">
                        <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                      </object>
                    </v-chip>
                    <span v-if="index === 1" class="primary--text body-2 subheader-font">(+{{ gamesModel.length - 1 }} {{ $t('finishingMap.more') }})</span>
                  </template>
                  <template v-slot:item="{item}">
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.homeTeamId}.png`" type="image/png" height="20" class="mr-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                    <span class="body-2">{{item.name}}</span>
                    <object :data="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/${item.awayTeamId}.png`" type="image/png" height="20" class="ml-2">
                      <img :src="`https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/crests/0.png`" height="20">
                    </object>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-col>
          </v-row>
          <v-row class="mx-0">
            <v-col class="d-flex pb-3 pl-0 justify-center" cols="12" v-if="$vuetify.breakpoint.smAndDown">
              <v-btn color="primary" class="monospace-font px-4" small outlined rounded @click="showShotOptions = !showShotOptions">
                  {{ showShotOptions ? $t('game.detail.hidePassOptions') : $t('game.detail.showPassOptions')}} <v-icon right > {{ showShotOptions ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
              </v-btn>
            </v-col>
            <v-row id="passing-location" class="px-2">
              <v-col class="d-flex pt-0 pb-0 pl-1" cols="12" v-if="showShotOptions">
                <div class="px-4 py-0 mt-2 mb-n2 primary--text font-weight-bold body-1">{{ $t('general.visualization') }}</div>
              </v-col>
              <v-col class="d-flex flex-wrap pt-0 pb-2 pl-1" cols="12" v-if="showShotOptions">
                <v-checkbox
                  v-model="checkboxCircles"
                  :label="$t('finishingMap.circles')"
                  color="secondary"
                  value="circles"
                  hide-details
                  class="px-4 py-0"
                  @change="updateShots"
                ><template v-slot:label><span class="body-1 primary--text">{{ $t('finishingMap.circles') }}</span></template></v-checkbox>
                <v-checkbox
                  v-model="checkboxCircles"
                  :label="$t('finishingMap.boxes')"
                  color="secondary"
                  value="boxes"
                  hide-details
                  class="px-4 py-0 pl-0"
                  @change="updateShots"
                ><template v-slot:label><span class="body-1 primary--text">{{ $t('finishingMap.boxes') }}</span></template></v-checkbox>
              </v-col>
            </v-row>
          </v-row>
          <v-row id="action-ending" class="px-2">
            <v-col cols="12" sm="12" class="pt-0 pb-0">
              <div class="d-flex flex-column">
                <div class="pl-2 mt-2 mb-n2 primary--text font-weight-bold body-1">
                  {{ $t('game.gameThreat.typeOfPlay') }}
                </div>
                <v-row>
                  <v-col class="d-flex flex-wrap pt-0 pb-2 pl-1" cols="12">
                    <v-checkbox
                      v-for="(typesPlay, index) in typeOfPlay" 
                      :key="index"
                      v-model="typeOfPlayModel"
                      :label="typesPlay.text"
                      color="secondary"
                      :value="typesPlay.value"
                      hide-details
                      class="px-4 py-0"
                      @change="updateShots()"
                      v-bind:class="{'pl-0': index % 2 === 1}"
                    ><template v-slot:label><span class="body-1 primary--text">{{ typesPlay.text }}</span></template></v-checkbox>
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col cols="12" sm="12" class="pt-0 pb-0">
              <div class="d-flex flex-column">
                <div class="pl-2 mt-2 mb-n2 primary--text font-weight-bold body-1">
                  {{ $t('game.gameThreat.actionEnding') }}
                </div>
                <v-row>
                  <v-col class="d-flex flex-wrap pt-0 pb-2 pl-5" cols="12">
                    <v-checkbox
                      v-for="(actionEnding, index) in actionEndings" 
                      :key="index"
                      v-model="actionEndingsModel"
                      :label="$t(`game.gameThreat.${actionEnding}`)"
                      color="secondary"
                      :value="actionEnding"
                      hide-details
                      class="py-0 me-5"
                      v-bind:class="{'pl-0': index % 2 === 1}"
                      @change="updateShots()"
                    ><template v-slot:label><span class="body-1 primary--text">{{ $t(`game.gameThreat.${actionEnding}`) }}</span></template></v-checkbox>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-row id="filters" class="px-2">
            <v-col cols="12" class="pt-0 pb-0">
              <div class="d-flex flex-column">
                <div class="pl-2 mt-2 mb-n2 primary--text font-weight-bold body-1">
                  {{ $t('general.period') }}
                </div>
                <v-row>
                  <v-col class="d-flex flex-wrap pt-0 pb-2 pl-1" cols="12" v-if="showShotOptions">
                    <v-checkbox
                      v-model="periods"
                      :label="$t('general.firstHalf')"
                      color="secondary"
                      value="period1"
                      hide-details
                      class="px-4 py-0"
                      @change="updateShots()"
                    ><template v-slot:label><span class="body-1 primary--text">{{ $t('general.firstHalf') }}</span></template></v-checkbox>
                    <v-checkbox
                      v-model="periods"
                      :label="$t('general.secondHalf')"
                      color="secondary"
                      value="period2"
                      hide-details
                      class="px-4 py-0 pl-0"
                      @change="updateShots()"
                    ><template v-slot:label><span class="body-1 primary--text">{{ $t('general.secondHalf') }}</span></template></v-checkbox>
                    <v-checkbox
                      v-if="showShotOptions && hasFirstOT"
                      v-model="periods"
                      :label="$t('general.firstPeriodOT')"
                      color="secondary"
                      value="period3"
                      hide-details
                      class="px-4 py-0"
                      @change="updateShots()"
                    ><template v-slot:label><span class="body-1 primary--text">{{ $t('general.firstPeriodOT') }}</span></template></v-checkbox>
                    <v-checkbox
                      v-if="showShotOptions && hasSecondOT"
                      v-model="periods"
                      :label="$t('general.secondPeriodOT')"
                      color="secondary"
                      value="period4"
                      hide-details
                      class="px-4 py-0 pl-0"
                      @change="updateShots()"
                    ><template v-slot:label><span class="body-1 primary--text">{{ $t('general.secondPeriodOT') }}</span></template></v-checkbox>
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col class="d-flex py-2" cols="12" sm="12" v-if="showShotOptions">
              <v-range-slider
                :label="$t('finishingMap.minutes')"
                thumb-label
                v-model="minutes"
                :min="rangeMinutes[0]"
                :max="rangeMinutes[1]"
                step="1"
                hide-details
                color="secondary"
                class="align-center px-2 py-0"
                @input="updateShots"
              >
                <template v-slot:label>
                  <div class="d-flex flex-column">
                    <span class="primary--text font-weight-bold body-1">{{ $t('finishingMap.minutes') }}</span>
                    <span class="body-2 subheader-font monospace-font">{{ `(${rangeMinutes[0]} - ${rangeMinutes[1]})` }}</span>
                  </div>
                </template>
              </v-range-slider>
            </v-col>
            <v-col class="d-flex py-2" cols="12" sm="12">
              <v-range-slider
                :label="$t('game.gameThreat.threat')"
                thumb-label
                v-model="threat"
                :max="threatMax"
                :min="threatMin"
                step="0.01"
                hide-details
                color="secondary"
                class="align-center px-2 py-0"
                @input="updateShots"
              >
                <template v-slot:label>
                  <div class="d-flex flex-column">
                    <span class="primary--text font-weight-bold body-1">{{ $t('game.gameThreat.threat') }}</span>
                    <span class="body-2 subheader-font monospace-font">{{ `(${threatMax} - ${threatMin})` }}</span>
                  </div>
                </template>
              </v-range-slider>
            </v-col>
          </v-row>
          <!--Download actions-->
          <div v-if="!stackedView" class="pb-2 px-1 mt-5">
            <v-divider></v-divider>
          </div>
          <div v-if="!stackedView" class="d-flex justify-end py-0 w-100 pr-1" id="image-download">
            <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small :x-small="!$vuetify.breakpoint.xsOnly" v-on:click.native="saveAsPNG()">
              <v-icon small class="mr-1">file_download</v-icon>
              <span class="">PNG</span>
            </v-btn>
            <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small :x-small="!$vuetify.breakpoint.xsOnly" v-on:click.native="saveAsSVG()">
              <v-icon small class="mr-1">file_download</v-icon>
              <span>SVG</span>
            </v-btn>
            <v-btn color="secondary" class="elevation-0 monospace-font white--text px-3 mx-1" rounded small :x-small="!$vuetify.breakpoint.xsOnly" :loading="loadingExport" v-on:click.native="onGenerateIFrameClick()">
              <v-icon small class="mr-1">share</v-icon>
              <span>Embed</span>
            </v-btn>
          </div>
        </v-card>
        <div class="flex-shrink-0 ml-2 align-self-start">
          <slot name="filters-toggle"></slot>
        </div>
      </v-col>
      <v-col cols="12" sm="12" :md="showFilters ? 8 : 10" id="chart" ref="chart" class="text-center">
        <PlayerAvatarMedia v-if="player && avatarSize && mediaMode && size" :player="headerPlayer" :width="size" :height="avatarSize.height" :id="`${playerId}-${chartId}-xT`"
          :margin="margin" :title="mediaModeData.upperText" :subtitle="mediaModeData.lowerText"
          :color="mediaModeData.borderColor" ref="playerAvatarMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          :comparisonTitle="mediaModeData.comparisonUpperText" :comparisonSubtitle="mediaModeData.comparisonLowerText" :comparisonColor="mediaModeData.comparisonBorderColor"
          :face="mediaModeData.face.dataUrl"
          :nationalTeam="mediaModeData.nationalTeam"
          :lineDistance="mediaModeData.lineLength"
          :lineWeight="mediaModeData.lineWeight" :avatarSize="mediaModeData.avatarSize"
          :upperTextFontSize="mediaModeData.upperTextFontSize" :upperTextFontWeight="mediaModeData.upperTextFontWeight"
          :lowerTextFontSize="mediaModeData.lowerTextFontSize" :lowerTextFontWeight="mediaModeData.lowerTextFontWeight"
          :fontFamily="mediaModeData.fontFamily" type="xTThreatMap"
          class="mt-2"></PlayerAvatarMedia>
        <XTChart
          v-if="size != 0 && player !== null"
          :size="size"
          :type="type"
          :key="xtMap"
          :player="player"
          :plays="filteredShots"
          :minXT="threat[0]"
          :maxXT="threat[1]"
          :language="currentUserLanguage"
          :typeOfPlay="typeOfPlayModel"
          :seasons="filteredSeasons"
          :playerName="player.name"
          :circlesAndBoxes="checkboxCircles"
          :homeFillColor="mediaModeData.leftFillColor"
          :awayFillColor="mediaModeData.rightFillColor"
          :homeBorderColor="mediaModeData.leftBorderColor"
          :awayBorderColor="mediaModeData.rightBorderColor"
          :mediaMode="mediaMode"
          :id="`${playerId}-${chartId}`"
          :gameId="gameId"
          :gameIds="gamesModel"
          :gameName="gameName"
          :minsPlayed="minsPlayed"
          :fontFamily="mediaModeData.fontFamily"
          :teamId="teamId || 0"
          :filterActionEndingText="playerFilterActionEndingText"
          :filterMinutesText="filterMinutesText"
          @sizeChange="onChartSizeChange($event)"
          @loaded="onLoaded($event)"
        />
        <DriblabSocialMedia v-if="player && avatarSize && size && mediaMode && mediaModeData.socialMedia"  :width="size" :height="50" :id="`${playerId}-${chartId}-xT`"
          :margin="margin" ref="driblabSocialMediaRef" :bgColor="mediaModeData.bgColor" :textColor="mediaModeData.textColor"
          :fontSize="mediaModeData.socialMediaFontSize" :fontWeight="mediaModeData.socialMediaFontWeight"
          :fontFamily="mediaModeData.fontFamily"
          :logoCfg="mediaModeData.logo" :sponsor="mediaModeData.sponsor.dataUrl" type="playerThreat"></DriblabSocialMedia>
      </v-col>
    </v-row>
    <ChartExportLinksModal ref="chartExportLinksModalRef" :title="player.name" v-if="player"
    :subtitle="$t('playerDetail.threatMap')"></ChartExportLinksModal>
    <Tour v-if="currentUser.showTour && playerSeasonData && playerSeasonData.length" name="playerThreatTour" :steps="tourSteps" />
  </v-container>
</template>

<script>
import * as d3 from "d3";

import PlayerService from '../../services/player/player.service';
import DocumentService from '../../services/document.service';
import UserChartService from '../../services/user-chart.service';
import XTChart from '../base/XTChart';
import MediaModeForm from '../base/MediaModeForm';
import DriblabSocialMedia from '../base/DriblabSocialMedia';
import PlayerAvatarMedia from './PlayerAvatarMedia';
import { getNeutralColors,userHasRole } from '../../utils/functions';
import { exportSvg,downloadPng,copyAndAppendElement } from '../../utils/exportToPNG';
import Dictionary from "../../dictionary";
import ChartExportLinksModal from '../base/ChartExportLinksModal';
import Tour from "../base/Tour";
import { v4 } from 'uuid';
import UserService from '../../services/user.service';
import * as moment from 'moment';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8081';

const API_URL = NODE_ENV === 'production' ? 'https://pro.driblab.com/embed-chart/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/embed-chart/'

export default {
  name: 'PlayerXTMap',
  components: {
    XTChart,
    MediaModeForm,
    PlayerAvatarMedia,
    DriblabSocialMedia,
    ChartExportLinksModal,
    Tour
  },
  props:{
    noMarginTop: { type: Boolean, default: false },
    playerId:{
      type: Number,
      required: false
    },
    stackedView:{
      type: Boolean,
      required: false
    },
    chartId:{
      type:Number,
      default: 0
    },
    headerPlayer:{
      type: Object,
      required: false
    },
    headerPlayerSeasonData:{
      type: Array,
      required: false
    },
    gamesPlayed:{
      type: Array,
      required: false
    },
    gameId:{
      type:Number,
      default: 0
    },
    gameName:{
      type: String,
      default: ""
    },
    gameSeasonId:{
      type:Number,
      default: 0
    },
    teamId:{
      type:Number,
      default: 0
    },
    language: {
      type: String,
      required: false
    },
    showFilters: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    "mediaMode": function(newVal, oldVal) {
      if(!this.mediaMode){
        this.mediaModeData = {
          borderColor:"#3366FF",fillColor:"#6d7de5",bgColor:"#ffffff0",upperText:null,lowerText:null,
          socialMedia:true,nationalTeam: false,textColor: this.defaultColors.textColor,axisColor:this.defaultColors.axisColor,logo:"color",
          comparisonBorderColor:"#000000",comparisonFillColor:"#7D7D7D",comparisonUpperText:null,comparisonLowerText: null,face:{},comparisonFace:{},
          upperTextFontWeight:"900",lowerTextFontWeight:"400",socialMediaFontWeight:"300",socialMediaFontSize:"14",sponsor:{}}
      }else{
        this.mediaModeData.axisColor = this.defaultColorsMediaMode.axisColor
        this.mediaModeData.textColor = this.defaultColorsMediaMode.textColor
      }
      this.mediaModeData.bgColor = this.mediaMode ? '#ffffff' : '#ffffff0';
      this.mediaModeData.face.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.player.playerId}.png`;
      this.mediaModeData.face.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0_${this.headerPlayer.male === false ? 'f' : 'm'}.png`;
      this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
      this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);
      this.onWindowResize(null,false)
    },
    showFilters() {
      this.$nextTick(() => {
        this.size = this.stackedView ? this.$refs.chart.clientWidth * 0.9 : this.$refs.chart.clientWidth * 0.75; // minus padding normal
        this.onWindowResize(null, true);
      });
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    currentUserLanguage() {
      return this.language ? this.language : this.$store.getters["auth/language"];
    },
    hasFirstOT(){
      return _.some(this.shots,(s) => s.periodId === 3)
    },
    hasSecondOT(){
      return _.some(this.shots,(s) => s.periodId === 4)
    },
    avatarSize(){
      return {
        width: this.size,
        height: this.size / 5.5
      }
    },
    defaultColors(){
      return {
        textColor: this.darkMode ? "#fff" : "#000",
        axisColor: this.darkMode ? "#2a2a2a" : "#fff",
        bgColor: "transparent"
      }
    },
    defaultColorsMediaMode(){
      return {
        textColor: "#000",
        axisColor: "#fff"
      }
    },
    lastSearchId() {
      return this.$store.state.auth.lastSearch;
    },
    allGames () {
      return this.gamesModel.length === this.gamesFiltered.length;
    },
    isGoalkeeper(){
      if (this.headerPlayer) return this.headerPlayer.fieldPositionId === 1; //GK
    },
    playerFilterActionEndingText() {
      if (this.actionEndingsModel.length === this.actionEndings.length || this.actionEndingsModel.length === 0) return '';
      const labels = this.actionEndingsModel.map(ae => this.$t(`game.gameThreat.${ae}`));
      if (labels.length <= 2) return labels.join(', ');
      return labels.slice(0, 2).join(', ') + ` (+${labels.length - 2})`;
    },
    filterMinutesText() {
      if (this.minutes[0] === this.rangeMinutes[0] && this.minutes[1] === this.rangeMinutes[1]) return '';
      return `${this.$t('table.roster.minutes')}: ${this.minutes[0]}' - ${this.minutes[1]}'`;
    },
    tourSteps(){
      return [
        {
          target: `#player-seasons`,
          header: {
            title: this.$t("tours.playerThreat.step1.title"),
          },
          content: this.$t("tours.playerThreat.step1.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#passing-location`,
          header: {
            title: this.$t("tours.playerThreat.step2.title"),
          },
          content: this.$t("tours.playerThreat.step2.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#action-ending`,
          header: {
            title: this.$t("tours.playerThreat.step3.title"),
          },
          content: this.$t("tours.playerThreat.step3.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#filters`,
          header: {
            title: this.$t("tours.playerThreat.step4.title"),
          },
          content: this.$t("tours.playerThreat.step4.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#image-download`,
          header: {
            title: this.$t("tours.playerThreat.step5.title"),
          },
          content: this.$t("tours.playerThreat.step5.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
        {
          target: `#chart`,
          header: {
            title: this.$t("tours.playerThreat.step6.title"),
          },
          content: this.$t("tours.playerThreat.step6.message"),
          params: {
            placement: "top",
            enableScrolling: false,
            highlight: true
          }
        },
      ];
    }
  },
  data() {
    return {
      size: 0,
      margin: null,
      grounds: [{id: 1, name: this.$t("general.all")},
                {id: 2, name: this.$t("general.home")},
                {id: 3, name: this.$t("general.away")},
                {id: 4, name: this.$t('general.last') + ' ' + this.$t('playerRecruitment.xGames',{0:6})},
                {id: 5, name: this.$t('general.last') + ' ' + this.$t('playerRecruitment.xGames',{0:12})}],
      groundModel: 1,
      type: 'player',
      player: null,
      xtMap: 0,
      shots: [],
      filteredShots: [],
      playerSeasonData: [],
      seasonDataSelectedModel: [],
      filteredSeasons: [],
      showShotOptions: this.$vuetify.breakpoint.smAndDown ? false : true,
      checkboxCircles: ['circles'],
      minutes: [0, 90],
      periods: ['period1','period2', 'period3', 'period4'],
      rangeMinutes: [0,90],
      threat: [0.05, 1],
      threatMax: 1,
      threatMin: 0.02,
      sizeMultiplier: 0.75,
      actionEndings: ['pass', 'shot', 'foul', 'other'],
      actionEndingsModel: ['pass', 'shot', 'foul', 'other'],
      typeOfPlay: [
        {text: Dictionary[this.$i18n.locale]["game"]["gameThreat"]['regularPlay'],value:'Regular Play'},
        {text: Dictionary[this.$i18n.locale]["game"]["gameThreat"]['setPiece'],value:'Set Piece'}
      ],
      typeOfPlayModel: ['Regular Play', 'Set Piece'],
      mediaMode: false,
      mediaModeData: {
                      borderColor:"#3366FF",fillColor:"#6d7de5",bgColor:"#ffffff0",upperText:null,lowerText:null,
                      socialMedia:true,nationalTeam: false,textColor:"#000",axisColor:"#fff",
                      logo:"color",comparisonBorderColor:"#000000",comparisonFillColor:"#7D7D7D",comparisonUpperText:null,comparisonLowerText: null,
                      face: {},comparisonFace:{},upperTextFontWeight:"900",lowerTextFontWeight:"400",
                      socialMediaFontWeight:"300",socialMediaFontSize:"14",sponsor:{}
                    },
      mediaModeFields: [
        {type:"text",label:"mediaMode.upperText",key:"upperText"},
        {type:"number",label:"mediaMode.upperTextFontSize",key:"upperTextFontSize"},
        {type:"radio",label:"mediaMode.upperTextFontWeight",key:"upperTextFontWeight",options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"text",label:"mediaMode.lowerText",key:"lowerText"},
        {type:"number",label:"mediaMode.lowerTextFontSize",key:"lowerTextFontSize"},
        {type:"radio",label:"mediaMode.lowerTextFontWeight",key:"lowerTextFontWeight",options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}]},
        {type:"radio",label:"mediaMode.fontFamily",key:"fontFamily",options:[{value:"NeueMontreal",label:"NeueMontreal"},{value:"NeueMontreal",label:"NeueMontreal"}]},
        {type:"color",label:"mediaMode.borderColor",key:"borderColor"},
        {type:"color",label:"mediaMode.bgColor",key:"bgColor"},
        {type:"color",label:"mediaMode.textColor",key:"textColor"},
        {type:"number",label:"mediaMode.avatarLineLength",key:"lineLength",force:true},
        {type:"number",label:"mediaMode.avatarLineWeight",key:"lineWeight",force:true},
        {type:"number",label:"mediaMode.avatarSize",key:"avatarSize",force:true},
        {type:"image",label:"mediaMode.face",key:"face"},
        {type:"switch",label:"mediaMode.nationalTeam",key:"nationalTeam"},
        {type:"switch",label:"mediaMode.socialMedia",key:"socialMedia"},
        {type:"number",label:"mediaMode.socialMediaFontSize",key:"socialMediaFontSize",force:true},
        {type:"radio",label:"mediaMode.socialMediaFontWeight",key:"socialMediaFontWeight"
          ,options:[{value:"100",label:"100"},{value:"300",label:"300"},{value:"400",label:"400"},{value:"500",label:"500"},{value:"700",label:"700"},{value:"900",label:"900"}],force:true},
        {type:"image",label:"mediaMode.sponsor",key:"sponsor",force:true,aspectRatio:16/9,imageRestriction:'none',resizable:true,stencilSize:{width:300,height:300}}
      ],
      chartSize: null,
      darkMode:
        this.$store.state.auth.user.darkMode || this.$vuetify.theme.dark,
      loadingExport: false,
      games: [],
      gamesFiltered: [],
      gamesModel: [],
      //Mins played on games selected
      minsPlayed: 0,
      isEmbed: false
    };
  },
  mounted: function() {
    this.mediaMode = (this.currentUser.mediaMode || this.currentUser.clientType === 'Media');
    this.size = this.$refs.chart.clientWidth * this.sizeMultiplier; // minus padding
  },
  async created() {
    window.addEventListener("resize", this.onWindowResize);
    this.player = this.headerPlayer;
    this.games = this.gamesPlayed;

    if(this.headerPlayerSeasonData){
      this.playerSeasonData = _.map(this.headerPlayerSeasonData, (h) => { h.compoundId = `${h.seasonId}-${h.teamId}`; h.compoundText = `${h.seasonName}-${h.teamName}`; return h; });
    }else{
      let seasonsData = await PlayerService.getPlayerTeamSeasonData(this.playerId, this.currentUser.clientId);
      this.playerSeasonData = _.map(seasonsData.data,(h) => { h.compoundId = `${h.seasonId}-${h.teamId}`; h.compoundText = `${h.seasonName}-${h.teamName}`; return h; });
    }
    this.filteredSeasons = this.playerSeasonData.slice(0, 1);

    //Get games of player if games are not received
    if(!this.games){
      await this.loadGamesPlayedOfPlayer();
    }
    // Default season : Last Regular season of the player's team
    let defaultSeason = this.playerSeasonData.find(psd => psd.regular && 
                                          psd.teamId === this.player.teamId && 
                                          psd.year === psd.leagueLastYear);

    if(!defaultSeason){
      // If there is no season, take last regular played in other team
      defaultSeason = this.playerSeasonData.find(psd => psd.regular && 
                                        psd.year === psd.leagueLastYear);
    }

    if(!defaultSeason){
      // If there is no season, take first regular from all seasons played
      defaultSeason = this.playerSeasonData.find(psd => psd.regular) || this.playerSeasonData[0];
    }
    this.seasonDataSelectedModel = [defaultSeason.compoundId];

    const seasonsSelected = this.playerSeasonData.filter(psd => this.seasonDataSelectedModel.includes(psd.compoundId));
    const teamIdsSelected = this.teamId > 0 ? this.teamId : seasonsSelected.map(psd => psd.teamId);
    const seasonIdsSelected = this.gameSeasonId > 0 ? this.gameSeasonId : seasonsSelected.map(psd => psd.seasonId);
    //Get threats of player
    let threatsData = await PlayerService.getXTOfPlayerAndSeasons(this.playerId, teamIdsSelected, seasonIdsSelected);
    this.shots = threatsData.data;

    this.mediaModeData.upperText = this.player.name;
    this.mediaModeData.lowerText = this.$t("playerDetail.threatMap");
    this.mediaModeData.face.src = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/${this.player.playerId}.png`;
    this.mediaModeData.face.fallBackSrc = `https://driblab-pro-images.s3.us-east-2.amazonaws.com/img/faces/0_${this.headerPlayer.male === false ? 'f' : 'm'}.png`;
    this.mediaModeData.sponsor.src = require(`@/assets/img/driblab_normal_color.png`);
    this.mediaModeData.sponsor.fallBackSrc = require(`@/assets/img/driblab_normal_color.png`);
    if(!this.mediaMode){
      this.mediaModeData.textColor = this.defaultColors.textColor;
      this.mediaModeData.axisColor = this.defaultColors.axisColor;
    }

    this.filterGames();
    this.updateMins();
    //this.minutes = this.rangeMinutes;
    this.updateShots();

    setTimeout(() => {
      UserService.putLastSearchRendered({id:this.lastSearchId});
    }, 250);

  },
  methods: {
    onWindowResize(e,force=false) {
      if (this.size != this.$refs.chart.clientWidth * this.sizeMultiplier) {
        this.size = this.$refs.chart.clientWidth * this.sizeMultiplier;
      }
      this.xtMap += 1;
      if(this.$refs.playerAvatarMediaRef){
        this.$refs.playerAvatarMediaRef.printD3(force)
      }
      if(this.$refs.driblabSocialMediaRef){
        this.$refs.driblabSocialMediaRef.printD3(force)
      }
      this.$forceUpdate();
    },
    toggleGames () {
      this.$nextTick(() => {
        if (this.allGames)
          this.gamesModel = []
        else {
          this.gamesModel = this.gamesFiltered.slice().map(g => g.gameId);
        }
      })
    },
    filterGames(){
      this.filteredSeasons = this.playerSeasonData.filter(s => this.seasonDataSelectedModel.includes(s.compoundId));
      let teamIds = this.filteredSeasons.map(s => s.teamId);
      let seasonIds = this.filteredSeasons.map(s => s.seasonId);
      let gamesOfSeasonAndTeam = this.games.filter(s => teamIds.includes(s.teamId) && seasonIds.includes(s.seasonId));
      switch (this.groundModel) {
        //All
        case 1:
          this.gamesFiltered = gamesOfSeasonAndTeam;
          break;
        //Home
        case 2:
          this.gamesFiltered = gamesOfSeasonAndTeam.filter(g => teamIds.includes(g.homeTeamId));
          break;
        //Away
        case 3:
          this.gamesFiltered = gamesOfSeasonAndTeam.filter(g => teamIds.includes(g.awayTeamId));
          break;
        case 4:
        case 5:
          this.gamesFiltered = gamesOfSeasonAndTeam.slice(0, this.groundModel === 4 ? 6 : 12);
          break;
        default:
          this.gamesFiltered = gamesOfSeasonAndTeam;
      }

      this.gamesModel = this.gamesFiltered.map(g => g.gameId);
    },
    async onSeasonBlur(){
      if (this.seasonDataSelectedModel.length) {
        const seasonsSelected = this.playerSeasonData.filter(psd => this.seasonDataSelectedModel.includes(psd.compoundId));
        const teamIdsSelected = seasonsSelected.map(psd => psd.teamId);
        const seasonIdsSelected = seasonsSelected.map(psd => psd.seasonId);

        let response = await PlayerService.getXTOfPlayerAndSeasons(this.playerId, teamIdsSelected, seasonIdsSelected);
        this.shots = response.data;
        this.onSelectChange();
      } else {
        this.seasonDataSelectedModel = [];
      }
    },
    onSelectChange(){
      this.filterGames();
      this.updateShots();
    },
    async loadGamesPlayedOfPlayer() {
      let gamesResponse = await PlayerService.getGamesPlayedOfPlayer(this.playerId);
      this.games = gamesResponse.data;
      //Create game name
      this.games.forEach(g => {
        g.name = `${g.homeTeamName} ${g.homeTeamScore}:${g.awayTeamScore} ${g.awayTeamName}`;
      });
    },
    isSetPiece(type) {
        if (type === 'Corner taken') return "Set Piece";
        if (type === 'Free kick') return "Set Piece";
        if (type === 'Free kick taken') return "Set Piece";
        if (type === 'From corner') return "Set Piece";
        if (type === 'Indirect') return "Set Piece";
        if (type === 'Penalty') return "Set Piece";
        if (type === 'Set piece') return "Set Piece";
        if (type === 'Throw-in') return "Set Piece";
        if (type === 'Throw-in set piece') return "Set Piece";

        if (type === 'Fast break') return "Regular Play";
        if (type === 'Keeper Throw') return "Regular Play";
        if (type === 'Regular play') return "Regular Play";

        return false;
    },
    updateMins(){
      this.rangeMinutes = [0,_.chain(this.shots).map(s => s.min).max().value()];
      this.rangeMinutes[1] = this.rangeMinutes[1] < 90 ? 90 : this.rangeMinutes[1];
      this.minutes = this.rangeMinutes;
      this.$forceUpdate();
    },
    async updateShots() {
      const minutesMaxFilter = this.minutes[1];
      this.filteredSeasons = this.playerSeasonData
        .filter(s => this.seasonDataSelectedModel.includes(s.compoundId));

      if(this.shots.length){
        //If gameId > 0, then filter by game to show just threat of that game
        if(this.gameId > 0){
          this.filteredShots = this.shots.filter(s => s.gameId == this.gameId);
        }else{
          this.filteredShots = this.shots
          .filter(s =>  this.gamesModel.includes(s.gameId))
          .filter(s => this.typeOfPlayModel.includes(this.isSetPiece(s.strategy)))
          .filter(s => _.some(this.periods, p => p.includes(s.periodId)))
          .filter(s => s.min >= this.minutes[0] && s.min <= minutesMaxFilter)
          .filter(s => {
            if (!this.actionEndingsModel.includes("pass")) {
              return s.type !== "PASS";
            }
            return true;
          })
          .filter(s => {
            if (!this.actionEndingsModel.includes("foul")) {
              return s.type !== "FOUL";
            }
            return true;
          })
          .filter(s => {
            if (!this.actionEndingsModel.includes("shot")) {
              return !["GOAL", "SAVED SHOT", "MISSED SHOT", "SHOT ON POST", "CHANCE MISSED"].includes(s.type);
            }
            return true;
          })
          .filter(s => {
            if (!this.actionEndingsModel.includes("other")) {
              return ["GOAL", "SAVED SHOT", "MISSED SHOT", "SHOT ON POST", "CHANCE MISSED", "PASS", "FOUL"].includes(s.type);
            }
            return true;
          });
        }
        //Count total minutes played of games selected
        this.minsPlayed = this.gamesFiltered.filter(g => this.gamesModel.includes(g.gameId)).reduce((acc, game) => (acc + game.minsPlayed), 0);
      }

      setTimeout(() => {this.onWindowResize(null,false);},100)
      //this.xtMap += 1;
    },
    saveAsPNG() {
      if(this.mediaMode){
        downloadPng(this.prepareSvgForMedia(), "Driblab_xT_" + this.player.name.replace(' ','_') + ".png");
      }else{
        downloadPng(document.getElementById(`pitchXT${this.player.playerId}-${this.chartId}SVG`),
        "Driblab_xT_" + this.player.name.replace(' ','_') + ".png");
      }
    },
    saveAsSVG() {
      if(this.mediaMode){
        exportSvg(this.prepareSvgForMedia(), "Driblab_xT_" + this.player.name.replace(' ','_'), true, this.mediaModeData.bgColor);
      }else{
        exportSvg(document.getElementById(`pitchXT${this.player.playerId}-${this.chartId}SVG`),
        "Driblab_xT_" + this.player.name.replace(' ','_'));
      }
    },
    getElementToExport(){
      if(this.mediaMode){
        return this.prepareSvgForMedia();
      }else{
        let svg = d3.select(`#pitchXT${this.player.playerId}-${this.chartId}SVG`)
          .node()
       return svg;
      }
    },
    onMediaModeChange(event){
      this.mediaMode = event;
    },
    onMediaModeDataChange(event){
      this.mediaModeData = {...event};
      setTimeout(() => {this.onWindowResize(null,this.mediaModeData.force);},666)
    },
    prepareSvgForMedia(){
      let parent = document.createElementNS('http://www.w3.org/2000/svg','svg');
      let heightAccum = 0;
      let yOffset = 120;
      parent.style.background = this.mediaModeData.bgColor;

      //COPY HEADER
      copyAndAppendElement(parent,document.querySelector(`#playerAvatarMedia${this.playerId}-${this.chartId}-xTSVG`),100,0)
      heightAccum += this.avatarSize.height;
      copyAndAppendElement(parent,document.querySelector(`#pitchXT${this.playerId}-${this.chartId}SVG`),100,this.avatarSize.height)
      heightAccum += this.chartSize.height;
      if(this.mediaModeData.socialMedia){
        copyAndAppendElement(parent,document.querySelector(`#driblabSocialMedia${this.playerId}-${this.chartId}-xTSVG`),100,this.avatarSize.height + this.chartSize.height)
        heightAccum += 50;
      }

      parent.setAttribute("width",this.chartSize.width);
      parent.setAttribute("height",heightAccum);
      return parent;
    },
    onChartSizeChange(event){
      this.chartSize = event;
    },
    onLoaded(event){
      //Emit when is loaded
      this.$emit("loaded", event);
    },
    async onGenerateIFrameClick(){
      this.isEmbed = true;
      let elToExport = this.getElementToExport();
      this.loadingExport = true;
      let key = v4();
      key = `${key}.json`;
      let chartObject = {
        awsKey:key,
        tool: 'player-threat',
        category: 'player',
        componentId: this.playerId,
        width: elToExport.getAttribute("width"),
        height: this.mediaMode ? elToExport.getAttribute("width") * 0.94 : elToExport.getAttribute("height")
      }
      let postResponse = await UserChartService.postChart(chartObject)
      let chartEntity = postResponse.data;

      this.$refs.chartExportLinksModalRef.open(chartEntity);
      this.loadingExport = false;

      let urlResponse = await UserChartService.getUploadURL(chartEntity.id,key);
      let uploadUrl = urlResponse.data;
      var jsonse = JSON.stringify({
        margin: this.margin,
        size: Number(chartEntity.width),
        height: Number(chartEntity.height),
        plays: this.filteredShots,
        circlesAndBoxes: this.checkboxCircles,
        playerPosition:this.playerPosition,
        playerSeasonData:this.filteredSeasons,
        player:this.player,
        typeOfPlay:this.typeOfPlayModel,
        minXT:this.threat[0],
        maxXT:this.threat[1],
        language:this.currentUserLanguage,
        mediaModeData: this.mediaModeData,
        mediaMode: this.mediaMode,
        playerAvatarKey: 0,
        key: this.xtMap,
        socialMediaKey: 2,
        type: this.type,
        id: `${this.player.playerId}-${this.chartId}`,
        chartType:"xt-map",
        filterMinutesRange: this.filterMinutesText,
        isEmbed: this.isEmbed,
        embedFactor: 1
      });

      var blob = new Blob([jsonse], {type: "application/json"});
      // let blob = exportSvgToFile(elToExport);
      await DocumentService.upload(uploadUrl,blob);
      this.postSearchChart(chartEntity);
      this.isEmbed = false;
    },
  async postSearchChart(chart){
      const authorized = true;
      let metaInfo = null;
      let category = "player";
      let urlId = this.playerId;

      metaInfo = JSON.stringify({
        link: `${API_URL}${chart.id}/key/${chart.awsKey}/compId/${chart.componentId}/catId/${chart.categoryId}/tId/${chart.toolId}`
      });
      const tool = 'embed';
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const browser = navigator.userAgent;
      let searchResponse = await UserService.postUserSearch(category, tool, urlId, authorized, this.$route.path, timeZone, browser, metaInfo);
      UserService.putLastSearchRendered({category,tool,id: searchResponse.data})
    },
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
    /*onMapTypeChange(event) {
      this.$emit("tabChanged", event);
    }*/
  },
  destroyed() {
    d3.selectAll('.tooltip').remove();
    window.removeEventListener("resize", this.onWindowResize);
  }
};
</script>

<style scoped>
  body > div.tooltip {
    font-family: 'NeueMontreal';
    pointer-events: none;
    position: absolute;
    background: none repeat scroll 0 0 #ffffff;
    padding: 5px 10px 5px 10px;
    border-radius: 4px;
    text-align: center;
    display: none;
    line-height: 1.5;
    color: #081F2C;
    box-shadow: 0px 3px 9px rgba(0, 0, 0, .15);
  }

  body > div.tooltip:after {
    box-sizing: border-box;
    display: block;
    width: 100%;
    line-height: 2.8;
    color: #ffffff;
    content: "\25BC";
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/views/player/PlayerThreat.vue